import imgJennyLee from "@assets/events-awards/dta/img-jenny.png";
import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";

/**
 * Component to render Jenny Lee Section on DTA Judges Page
 */
const JennyLeeSection = (): React.ReactElement => {
  return (
    <AccordionV2
      testId="jenny-lee-section-component"
      className="border border-t-0 border-gray-175 bg-gray-150 py-4"
      headerChildren={
        <EventsAwardsAccordionHeader
          title="Ms Jenny Lee"
          className="tracking-normal"
        />
      }
      arrowClassName="border-none h-auto w-auto -rotate-90 mr-6"
      isArrowRight
    >
      <div className="mt-4 flex flex-col border-t border-gray-175 px-6 pt-4 md:flex-row">
        <div className="mb-6 h-auto w-8/12 pr-4 md:mb-2 md:w-2/12 md:pr-5">
          <img
            src={imgJennyLee}
            width={576}
            height={283}
            alt="ms-jenny-lee"
            className="object-contain"
          />
        </div>

        <div className="md:w-8/12 md:pl-1 md:pr-1">
          <p className="mb-0 font-bold">Ms Jenny Lee</p>

          <p className="font-bold">Senior Managing Partner Granite Asia</p>

          <p>
            Jenny Lee is a senior managing partner at Granite Asia and has been
            with the firm senior leadership since 2005.
          </p>

          <p>
            Jenny brings decades of experience investing in innovation and
            technology across Asia and globally, with a proven track record of
            translating capital into real economic impact. At Granite Asia, she
            has led the firm through a significant evolution — from a venture
            capital specialist into a multi-asset investment platform spanning
            private credit and growth equity.
          </p>

          <p className="mb-0">
            A self-starter, an investor and an entrepreneur, she has been
            instrumental in backing technology-enabled businesses that drive
            productivity, digitization, and new innovative consumer applications
            and products. Connecting businesses and founders across markets,
            industries and applications with technology innovation, she is best
            known for investments in sectors like Consumer Tech, Food and
            Agritech, Energy Sustainability and Automation Technologies. Her
            portfolio includes 21 companies valued at over $1 billion each. She
            has had 18 IPOs up to date, including 5 recent IPOs since 2021,
            across 5 different global exchanges, and numerous portfolio company
            exits via M&A.
          </p>

          <p>
            Jenny’s global investment track record over two decades and early
            operation and finance work experience with Singapore Aerospace in
            Singapore; Morgan Stanley, and JAFCO Asia in Hong Kong enhanced her
            role as a preferred board member with deep domain expertise and
            global investment experience.
          </p>

          <p>
            Born and raised in Singapore, Jenny is highly respected in the Asia
            business community and serves as a board member of Temasek since
            2022. She also serves on the governing boards of both Lee Kuan Yew
            School of Public Policy and Duke-NUS Medical School. In addition,
            she is also a member of Singapore’s RIEC; Singapore Business
            Federation; Asia Business Council; and the International Advisory
            Council of Edmond de Rothschild.
          </p>

          <p>
            Jenny has been a member of the Forbes Global 100 VC Midas list since
            2012 and was the first woman to break the top 10 in 2015. She was
            also recognised by Forbes as one of the World’s 100 Most Powerful
            Women in the past 3 years (2022-2024). In 2019, Jenny was named to
            the Forbes Asia Power Businesswomen 25 list and received the
            Business Times’s Outstanding Overseas Executive Award. In 2016, she
            was named to the Vanity Fair New Establishment list, Fast Company
            Most Creative People in Business list, and is consistently
            recognised by The New York Times and CB Insights among the top 100
            venture capital investors worldwide, ranking #8 among top venture
            capitalists in Asia.
          </p>

          <p>
            Jenny graduated from Cornell University with an M.S. and a B.Sc. in
            Electrical Engineering and an MBA from Kellogg School of Management,
            Northwestern University.
          </p>
        </div>
      </div>
    </AccordionV2>
  );
};
export default JennyLeeSection;
